import { defineAsyncComponent } from 'vue';

export default {
    slug: 'contracts',
    ability: 'contracts',
    components(app) {
        app.component(
            'app-contracts',
            defineAsyncComponent(() => import('./components/ContractsList.vue'))
        );
    },
    routes: [
        {
            path: 'contracts',
            name: 'contract-list',
            component: () => import('@modules/Contracts/Resources/js/pages/contracts/List.vue'),
            // What the list asks for as it opens, in one request (utils/listBootstrap.js).
            meta: { listBootstrap: { list: 'contracts' } },
            children: [
                {
                    path: ':id(\\d+)',
                    name: 'contract-preview',
                    component: () => import('@modules/Contracts/Resources/js/pages/contracts/Preview.vue'),
                    redirect: { name: 'contract-overview' },
                    props: true,
                    children: [
                        {
                            // Empty, like every other overview tab in the app. It
                            // used to repeat the parent's absolute path, so
                            // navigating here from a sibling tab matched the
                            // parent rather than swapping the child: the leaving
                            // tab hung in its out-in transition and the overview
                            // never mounted. Same URL either way.
                            path: '',
                            name: 'contract-overview',
                            component: () =>
                                import('@modules/Contracts/Resources/js/pages/contracts/preview/Overview.vue'),
                            props: true
                        },
                        {
                            path: 'signatures',
                            name: 'contract-signatures',
                            component: () =>
                                import('@modules/Contracts/Resources/js/pages/contracts/preview/Signatures.vue'),
                            props: true
                        },
                        {
                            path: 'edit',
                            name: 'contract-edit-tab',
                            component: () => import('@modules/Contracts/Resources/js/pages/contracts/preview/Edit.vue'),
                            props: true
                        },
                        {
                            path: 'audit',
                            name: 'contract-audit',
                            component: () =>
                                import('@modules/Contracts/Resources/js/pages/contracts/preview/AuditTrail.vue'),
                            props: true
                        },
                        {
                            path: 'comments',
                            name: 'contract-comments',
                            component: () => import('@/components/base/tabs/TabComments.vue'),
                            props: true
                        },
                        {
                            path: 'documents/:docPath(.*)*',
                            name: 'contract-documents',
                            component: () => import('@/components/base/tabs/TabDocuments.vue'),
                            props: true
                        }
                    ]
                }
            ]
        },
        {
            path: 'contracts/new',
            name: 'contract-new',
            component: () => import('@modules/Contracts/Resources/js/pages/contracts/Form.vue')
        },
        {
            path: 'contract-templates',
            name: 'contract-template-list',
            component: () => import('@modules/Contracts/Resources/js/pages/contracts/Templates.vue')
        },
        {
            path: 'contract-templates/new-remote',
            name: 'contract-template-new-remote',
            component: () => import('@modules/Contracts/Resources/js/pages/contracts/RemoteTemplateForm.vue')
        },
        {
            path: 'contract-templates/:id(\\d+)',
            name: 'contract-template-preview',
            component: () => import('@modules/Contracts/Resources/js/pages/contracts/template/Preview.vue'),
            redirect: { name: 'contract-template-overview' },
            props: true,
            children: [
                {
                    path: '',
                    name: 'contract-template-overview',
                    component: () =>
                        import('@modules/Contracts/Resources/js/pages/contracts/template/preview/Overview.vue'),
                    props: true
                },
                {
                    path: 'documents/:docPath(.*)*',
                    name: 'contract-template-documents',
                    component: () => import('@/components/base/tabs/TabDocuments.vue'),
                    props: true
                }
            ]
        }
    ],
    portalRoutes: [
        {
            path: 'contracts',
            name: 'portal-contracts',
            component: () => import('@modules/Contracts/Resources/js/portal/Contracts.vue')
        },
        {
            path: 'contracts/:id(\\d+)',
            name: 'portal-contract-detail',
            component: () => import('@modules/Contracts/Resources/js/portal/ContractDetail.vue'),
            props: true
        }
    ],
    // Contracts settings live as tabs inside the CRM settings screen
    // (injected as children of `settings-crm`, see getOrgRoutes()).
    crmTabs: () => [
        {
            position: 30,
            title: i18n.t('E-Signatures'),
            icon: 'draw',
            route: 'settings-contracts-signature',
            ability: 'settings.contracts'
        }
    ],
    crmRoutes: [
        {
            path: 'signature',
            name: 'settings-contracts-signature',
            component: () => import('@modules/Contracts/Resources/js/pages/contracts/settings/SignatureSettings.vue')
        },
        {
            path: 'onespan',
            name: 'settings-contracts-onespan',
            component: () => import('@modules/Contracts/Resources/js/pages/contracts/settings/OneSpanSettings.vue')
        }
    ],
    nav: () => ({
        section: 'crm',
        items: [
            {
                title: i18n.t('Contracts'),
                icon: 'file-sign',
                to: { name: 'contract-list' },
                position: 4
            }
        ]
    }),
    widgets: () => [
        {
            id: 'recent-contracts',
            label: i18n.t('Recent contracts'),
            icon: 'file-sign',
            component: () => import('@modules/Contracts/Resources/js/pages/dashboards/widgets/RecentContracts.vue'),
            size: 'is-6'
        }
    ]
};
